import { useLoader } from 'react-three-fiber';
import { TextureLoader } from 'three';

function useTexture(url) {
  return useLoader(TextureLoader, url);
}

useTexture.preload = url => useLoader.preload(TextureLoader, url);

export { useTexture };
